<template>
  <div class="desktop-container">
    <div class="desktop-content">
      <div style="width: 260px; margin-left: 100px">
        <svg width="260" height="80" viewBox="0 0 260 80" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.8194 48.2378C62.9392 49.3386 64.3988 50.3412 66.1984 51.2455C67.9981 52.1498 69.9776 52.602 72.1371 52.602C72.657 52.602 73.1969 52.5528 73.7567 52.4545C74.3166 52.3562 74.8165 52.1891 75.2564 51.9532C75.6963 51.7173 76.0562 51.4028 76.3362 51.0096C76.6161 50.6164 76.7561 50.1053 76.7561 49.4763C76.7561 48.454 76.2262 47.6087 75.1664 46.9403C74.1067 46.2719 72.557 45.6035 70.5175 44.9351L68.298 44.2274C67.0582 43.8342 65.8085 43.3231 64.5488 42.694C63.2891 42.0649 62.1594 41.3081 61.1596 40.4234C60.1598 39.5388 59.35 38.4969 58.7301 37.2977C58.1103 36.0985 57.8003 34.6929 57.8003 33.0809C57.8003 31.2723 58.1403 29.5915 58.8201 28.0385C59.5 26.4854 60.4897 25.129 61.7894 23.9691C63.0892 22.8093 64.6988 21.905 66.6184 21.2562C68.5379 20.6075 70.7574 20.2831 73.2769 20.2831C75.2364 20.2831 77.016 20.4601 78.6157 20.8139C80.2153 21.1678 81.615 21.6003 82.8147 22.1114C84.0144 22.6225 85.0342 23.1729 85.874 23.7627C86.7138 24.3525 87.3537 24.8833 87.7936 25.3551L82.3948 32.0783C80.9951 31.0561 79.5355 30.2206 78.0158 29.5718C76.4961 28.9231 74.9365 28.5987 73.3368 28.5987C72.817 28.5987 72.2971 28.6577 71.7772 28.7757C71.2573 28.8936 70.7874 29.0706 70.3675 29.3065C69.9476 29.5424 69.6077 29.8471 69.3477 30.2206C69.0878 30.5941 68.9578 31.0561 68.9578 31.6065C68.9578 32.1963 69.1078 32.7074 69.4077 33.1399C69.7077 33.5724 70.1176 33.9459 70.6375 34.2604C71.1573 34.575 71.7872 34.86 72.527 35.1156C73.2669 35.3712 74.0567 35.6365 74.8965 35.9118L76.8161 36.5015C78.1758 36.934 79.5554 37.4353 80.9551 38.0054C82.3548 38.5755 83.6145 39.3422 84.7343 40.3055C85.854 41.2688 86.7738 42.4679 87.4937 43.903C88.2135 45.3381 88.5734 47.0975 88.5734 49.1814C88.5734 50.99 88.1435 52.6609 87.2837 54.1943C86.4239 55.7277 85.2642 57.0448 83.8045 58.1457C82.3448 59.2466 80.6252 60.1018 78.6456 60.7112C76.6661 61.3206 74.5566 61.6253 72.3171 61.6253C68.318 61.6253 64.9687 61.1044 62.2693 60.0624C59.5699 59.0205 57.2805 57.6149 55.4009 55.8457L61.8194 48.2378ZM92.2178 21.3447H102.835V60.6817H92.2178V21.3447ZM128.554 38.2118H144.991V55.9636C142.591 57.9688 139.842 59.4137 136.742 60.2983C133.643 61.183 130.534 61.6253 127.415 61.6253C124.175 61.6253 121.266 61.1437 118.687 60.1804C116.107 59.2171 113.918 57.841 112.118 56.0521C110.318 54.2631 108.949 52.0909 108.009 49.5352C107.069 46.9796 106.599 44.1094 106.599 40.9247C106.599 37.9366 107.109 35.1746 108.129 32.6386C109.149 30.1026 110.578 27.9205 112.418 26.0923C114.258 24.264 116.447 22.8388 118.986 21.8165C121.526 20.7942 124.335 20.2831 127.415 20.2831C130.734 20.2831 133.843 20.8237 136.742 21.905C139.642 22.9862 142.071 24.7849 144.031 27.3013L137.132 34.1425C135.893 32.9236 134.563 31.9211 133.143 31.1347C131.724 30.3484 130.074 29.9552 128.194 29.9552C126.475 29.9552 124.955 30.2501 123.635 30.8398C122.316 31.4296 121.206 32.2258 120.306 33.2284C119.406 34.231 118.717 35.4105 118.237 36.7669C117.757 38.1234 117.517 39.5683 117.517 41.1017C117.517 42.7923 117.777 44.3158 118.297 45.6723C118.817 47.0288 119.536 48.1886 120.456 49.1519C121.376 50.1152 122.496 50.8622 123.815 51.393C125.135 51.9238 126.615 52.1891 128.254 52.1891C129.574 52.1891 130.834 52.0319 132.034 51.7173C133.233 51.4028 134.393 50.8524 135.513 50.066V46.2915H128.554V38.2118ZM149.655 21.3447H159.313L174.669 43.2838V21.3447H185.167V60.6817H176.109L160.153 38.0939V60.6817H149.655V21.3447ZM202.188 21.3447H214.365L228.522 60.6817H217.065L214.485 52.543H201.108L198.469 60.6817H187.491L202.188 21.3447ZM212.326 44.9351L207.887 30.486L203.268 44.9351H212.326ZM230.847 21.3447H241.464V51.4814H260V60.6817H230.847V21.3447Z"
            fill="#272C31"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.64981 13.5877C5.5215 11.5364 9.54083 12.1623 11.6272 14.9856L43.1086 57.5861C45.195 60.4095 44.5585 64.3611 41.6868 66.4123C38.8151 68.4636 34.7957 67.8377 32.7093 65.0144L1.22793 22.4139C-0.858477 19.5906 -0.221878 15.6389 2.64981 13.5877Z"
            fill="#24C185"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.9818 1.20724C22.8535 -0.844015 26.8729 -0.21814 28.9593 2.60517L40.2926 17.9414C42.379 20.7647 41.7424 24.7163 38.8707 26.7676C35.999 28.8188 31.9797 28.1929 29.8933 25.3696L18.56 10.0334C16.4736 7.21012 17.1102 3.2585 19.9818 1.20724Z"
            fill="#24C185"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.46585 53.2325C8.33754 51.1812 12.3569 51.8071 14.4433 54.6304L25.7766 69.9666C27.863 72.7899 27.2264 76.7415 24.3547 78.7928C21.483 80.844 17.4637 80.2181 15.3773 77.3948L4.04397 62.0586C1.95756 59.2353 2.59416 55.2837 5.46585 53.2325Z"
            fill="#24C185"
          />
        </svg>
        <div style="text-align: right">
          <div style="margin-top: 30px; font-size: 18px; color: #434141">시그널</div>
          <div style="margin-top: 8px; font-size: 14px; color: #434141">원하는 소식을 가장 빠르고<br />정확하게 전달해드립니다.</div>
        </div>
        <button class="button primary mt40" @click="buttonClick('click-desktop-about-signal')">회사소개</button>
        <button class="button outline mt16" @click="buttonClick('click-desktop-retry-again')">실검 다시하기</button>
        <button class="button outline mt16" @click="buttonClick('click-desktop-notification')">공지사항</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" })
  },
  methods: {
    buttonClick(type) {
      gtag("event", type)
      switch (type) {
        case "click-desktop-about-signal":
          // window.open("/news/guide", "_blank")
          window.open("https://signal.oopy.io/", "_blank")

          break
        case "click-desktop-retry-again":
          window.open("/news/tip", "_blank")
          break
        case "click-desktop-notification":
          window.open("https://www.youtube.com/watch?v=aR3R7ABDmvA&t=1s", "_blank")
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.desktop-container {
  position: relative;
  width: 540px;
  display: none;
  background: #d6dbe0;

  @include desktop {
    display: block;
  }
  .desktop-content {
    position: fixed;
    top: 130px;
    .button {
      width: 260px;
      height: 56px;
      border-radius: 8px;
      cursor: pointer;

      &.primary {
        background: #24c185 !important;
        color: white;
      }
      &.outline {
        border: 1px solid #24c185;
        color: #24c185;
      }
    }
  }
}
</style>
